import { createContext, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "@stream-io/stream-chat-css/dist/css/index.css";
import "./App.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import CreatorLogin from "./components/creator/CreatorLogin";
import CreatorSignup from "./components/creator/CreatorSignup";
import Home from "./components/Home";
import UserLogin from "./components/user/UserLogin";
import UserSignup from "./components/user/UserSignup";
import CreatorHome from "./components/creator/CreatorHome";
import UserHome from "./components/user/UserHome";
import UserAddCreator from "./components/user/UserAddCreator";
import UserProfile from "./components/user/UserProfile";
import { Toaster } from "react-hot-toast";
import CreatorProfile from "./components/creator/CreatorProfile";
import CreatorChats from "./components/creator/CreatorChats";
import UserChats from "./components/user/UserChats";
import PurchaseToken from "./components/user/PurchaseToken";
import LivePage from "./components/creator/LivePage";
import CreatorGallery from "./components/creator/CreatorGallery";
import CreatorProfilePage from "./components/user/CreatorProfilePage";
import CreatorLive from "./components/user/CreatorLive";
import Terms from "./components/common/Terms";
import Community from "./components/common/Community";
import Privacy from "./components/common/Privacy";
import MainHome from "./components/Home/MainHome"
import AddbankDetails from "./components/creator/AddbankDetails";
import UpdateProfile from "./components/creator/UpdateProfile";
import UserUpdateProfile from "./components/user/UserUpdateProfile"
export const Data = createContext("");

function App() {
  const [userData, setUserData] = useState({});

  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />
      <BrowserRouter>
        <Data.Provider value={{ userData, setUserData }}>
          <Routes>
            <Route exact path="/" element={<MainHome />} />
            <Route exact path="/login" element={<Home />} />

            <Route exact path="/terms" element={<Terms />} />
            <Route exact path="/community" element={<Community />} />
            <Route exact path="/privacy" element={<Privacy />} />

            <Route exact path="/creator/signup" element={<CreatorSignup />} />
            <Route exact path="/creator/login" element={<CreatorLogin />} />
            <Route exact path="/creator/" element={<CreatorHome />} />
            <Route exact path="/creator/chats" element={<CreatorChats />} />
            <Route exact path="/creator/profile" element={<CreatorProfile />} />
            <Route exact path="/creator/live" element={<LivePage />} />
            <Route exact path="/creator/gallery" element={<CreatorGallery />} />

            <Route exact path="/user/signup" element={<UserSignup />} />
            <Route exact path="/user/login" element={<UserLogin />} />
            <Route exact path="/user/" element={<UserHome />} />
            <Route exact path="/user/search" element={<UserAddCreator />} />
            <Route exact path="/user/chats" element={<UserChats />} />
            <Route exact path="/user/profile" element={<UserProfile />} />
            <Route exact path="/creator/bankdetails" element = {<AddbankDetails/>} />
            <Route exact path="/creator/updateprofile" element = {<UpdateProfile/>} />
            <Route exact path="/user/updateprofile" element = {<UserUpdateProfile />} />
            <Route
              exact
              path="/user/creator/:email"
              element={<CreatorProfilePage />}
            />
            <Route
              exact
              path="/user/creator/live/:email/:room_id"
              element={<CreatorLive />}
            />
            <Route
              exact
              path="/user/purchase-token"
              element={<PurchaseToken />}
            />
          </Routes>
        </Data.Provider>
      </BrowserRouter>
    </>
  );
}

export default App;
